// import SvgIcon from '@material-ui/core/SvgIcon';

// function EditIcon(props) {
//   return (
//     <SvgIcon {...props}>
//     <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
//     </SvgIcon>
//   );
// }

const TABLE_COLUMNS = [
  {
    key: 'datestamp',
    label: 'Date',
    style: {
      width: 'auto',
    }
    },
  {
    key: 'eventName',
    label: 'Event',
    style: {
      width: 'auto',
    }
  },
  {
    key: 'vidTitle',
    label: 'Video Title',
    style: {
      width: 'auto',
    }
  },
  {
    key: 'eventDuration',
    label: 'Event Duration',
    style: {
      width: 'auto',
    }
  },
  {
    key: 'country',
    label: 'Country',
    alignRight: false,
    style: {
      width: 'auto',
    }
  },
  {
    key: 'state',
    label: 'State',
    alignRight: false,
    style: {
      width: 'atuto',
    }
    }, 
  {
    key: 'organization',
    label: 'Organization',
    style: {
      width: 'auto',
    }
    },
     {
      key: 'userdevice',
      label: 'User',  
      style: {
        width: 'auto',
      }
    },
  {
    key: 'cellular',
    label: 'Cellular',
    alignRight: false,
    style: {
      width: 'auto',
    }
  },
  {
    key: 'wifi',
    label: 'Viewed on WIFI',
    style: {
      width: 'auto',
    },
  }, 
  {
    key: 'when_shareEventLog',
    label: 'When Shared',
    style: {
      width: 'auto',
    }
  },
  {
    key: 'where_shareEventLog',
    label: 'Where Shared',
    style: {
      width: 'auto',
    }
  }
  ];

module.exports = TABLE_COLUMNS;
